export const rupees = (n) => `₹${(Number(n || 0) / 100).toFixed(2)}`;
export const localDate = (value) => {
  if (!value) {
    return undefined;
  }
  const d = new Date(value);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
};
export const date = (n) => (n ? new Date(n).toLocaleString() : "—");
